import * as React from "react"
import { GroupByDateType, GroupByDate } from "../../../components/GroupByDate"
import { BPMChart } from "../../../components/Chart"
import { resultDateTransformer } from "../../../utils/date"
import { BPMAnalyticsAPI } from "../../../api"
import { SeriesTemplate, CommonSeriesSettings, ArgumentAxis, Label, TickInterval, Legend, Series } from "devextreme-react/chart"
import { GroupByType } from "../../../components/GroupByType"

export const OneTimePurchasesChart: React.FunctionComponent<{}> = () => {

    const [groupDateBy, setGroupDateBy] = React.useState<GroupByDateType>('day')
    const [groupBy, setGroupBy] = React.useState<string | undefined>('membership')

    const toolbarItems = GroupByType([{ val: 'membership', display: 'Membership' }], groupBy, (selected) => {
        setGroupBy(selected)
    }).concat(GroupByDate(groupDateBy, (selected) => {
        setGroupDateBy(selected)
    }))

    return (
        <BPMChart title='One Time Purchases' type='bar'
            additionalParams={{ groupBy: groupBy, groupDateBy }}
            onRequestLoad={(options, signal) => {
                return resultDateTransformer(BPMAnalyticsAPI.get<any>('one-time-purchases', options, signal))
            }} toolBarItems={() => toolbarItems}>
            {groupBy && <SeriesTemplate
                nameField={groupBy}
            />}
            {!groupBy && <Series name='Purchases' />}
            <CommonSeriesSettings type='bar'
                valueField="count"
                argumentField="date">
            </CommonSeriesSettings>
            <ArgumentAxis>
                <Label format={groupDateBy == 'month' ? 'month' : "shortDate"} />
                <TickInterval days={groupDateBy == 'day' ? 1 : undefined} weeks={groupDateBy == 'week' ? 1 : undefined} months={groupDateBy == 'month' ? 1 : undefined} />
            </ArgumentAxis>

            <Legend visible />
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Dashboard/charts/OneTimePurchasesChart.tsx